import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewProfile = () => { 
    return useQuery({ 
        queryKey: ['viewProfile'], 
        queryFn: async () => { 
            const res = await api.get('/me', {
            }); 
            return res.data; 
        }
     });
};  